export interface IPunchRule {
    Id: string
    Name: string
    Description: string
    DailyRule: boolean
    FullTimecard: boolean
    RuleType: EPunchRuleType
    CSharpScript: string
    RuleVersion: EPunchRuleVersion
    Stage: number,
    AutoApprovePunchSets: boolean
}

export enum EPunchRuleType {
    SingleDay = 0,
    MultiDay = 1,
    DailyPunchRule = 2,
    PunchDayGroupingRule = 3,
    BonusPayRule = 4,
    MealPenaltyRule = 5,
    GuaranteedMinimumHourRule = 6
}

export enum EPunchRuleVersion {
    V1 = 0,
    V2 = 1,
}